// Only the authenticated server resolves effective permissions.
export function can(user, permission) {
  return user?.effective_permissions?.[permission] === true;
}
export function canSeeEconomics(user) {
  return can(user, 'economic.summary') && (user?.active_site_id !== 'all' || can(user, 'economic.multisite'));
}
export const ROUTE_PERMISSIONS = {
  '/veicoli':'vehicles.read', '/assegnazioni':'rentals.read', '/noleggi':'rentals.read',
  '/consegne':'rentals.handover', '/manutenzioni':'maintenances.read', '/scadenze':'deadlines.read',
  '/costi':'costs.read', '/rifornimenti':'refuelings.read', '/danni':'damages.read', '/multe':'fines.read',
  '/calendario':'vehicles.read', '/tariffe':'tariffs.read', '/economia':'economic.summary',
  '/report':'statistics.operational', '/clienti':'customers.read', '/fornitori':'suppliers.read',
};
// Users, permissions and sites are non-delegable on the server: no permission
// grants them, only the administrator profile. This is the single role check.
export function canAdministerCompany(user) {
  return user?.role === 'admin';
}
export const ROLE_LABELS = {admin: "Amministratore", fleet_manager: "Fleet Manager", operator: "Operatore", driver: "Autista"};

export function canOpenRoute(user, path) {
  const base = '/' + path.split('/').filter(Boolean)[0];
  if (['/utenti','/sedi'].includes(base)) return canAdministerCompany(user);
  if (base === '/impostazioni') return !!user;
  if (base === '/consegne') return can(user,'rentals.handover') || can(user,'rentals.dispatch') || can(user,'rentals.handover_collect');
  if (base === '/calendario') return can(user,'vehicles.read') && can(user,'rentals.read');
  if (base === '/report') return canSeeEconomics(user) || (can(user,'statistics.operational') && (user.active_site_id !== 'all' || can(user,'statistics.multisite')));
  if (base === '/economia') return canSeeEconomics(user);
  // Everyone sees at least their own activity (server: visible_activity).
  if (base === '/attivita') return !!user;
  return ROUTE_PERMISSIONS[base] ? can(user, ROUTE_PERMISSIONS[base]) : true;
}
